import { createStore } from "vuex";

export default createStore({
  state: {
    keyword: "",
    page: 1,
    quizResetSignal: 0,
  },
  actions: {
    setSearchData({ commit }, data) {
      this.state.keyword = data.keyword;
      this.state.page = data.page;
    },
  },
  mutations: {
    triggerQuizReset(state) {
      state.quizResetSignal += 1;
    },
  },
  getters: {
    getSearchKeyword(state) {
      return state.keyword;
    },
    getSearchPage(state) {
      return state.page;
    },
    getQuizResetSignal(state) {
      return state.quizResetSignal;
    },
  },
});
